import { lazy } from 'react';
import { SettingTabsKeys } from '../types';
const ProfileRoute = lazy(() => import('../screens/Profile'));
const PlanRoute = lazy(() => import('../screens/Plan'));
const ESigningRoute = lazy(() => import('../screens/ESigning'));
const ApiManagementRoute = lazy(() => import('../screens/ApiManagement'));
export function getComponentRoute(route) {
    switch (route) {
        case SettingTabsKeys.Plan:
            return PlanRoute;
        case SettingTabsKeys.Esigning:
            return ESigningRoute;
        case SettingTabsKeys.Api:
            return ApiManagementRoute;
        case SettingTabsKeys.Profile:
        default:
            return ProfileRoute;
    }
}
